import React, {Fragment, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import * as api from "../../../../apis/platforms/admin/externalExpress";
import useAntTable from "../../../../utils/useAntTable";
import withAuth from "../../../../utils/withAuth";
import {Button, Divider, Popconfirm, Space} from "antd";
import ModifyModal from "./modifyModal";
import useFormModal from "../../../../utils/useFormModal";
import {useRequest} from "ahooks";
import UploadModal from "../../../../components/UploadModal";


const AddButton = withAuth('add', Button)
const EditFragment = withAuth('edit', Fragment)
const DeletePopconfirm = withAuth('delete', Popconfirm)

function ExternalExpress() {

    const {tableProps, form, search, refresh} = useAntTable(api.getExternalExpressMappings, {})
    const [uploadModalOpen, setUploadModalOpen] = useState(false)

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.modifyExternalExpressMapping,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const {run: onImport, loading: importing} = useRequest(api.importExternalExpressMappings, {
        manual: true,
        onSuccess: () => {
            setUploadModalOpen(false)
            refresh()
        }
    });

    const {run: onDelete} = useRequest(api.deleteExternalExpressMapping, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '快递名称',
            dataIndex: 'name',
            search: true
        },
        {
            title: '外部快递名称',
            dataIndex: 'externalName',
        },
        {
            title: '外部快递Key',
            dataIndex: 'externalKey',
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>
                    <EditFragment>
                        <a onClick={() => setVisible(true, record)}>编辑</a>
                        <Divider type="vertical"/>
                    </EditFragment>
                    <DeletePopconfirm title={'是否确认删除'} onConfirm={() => onDelete(record.id)}>
                        <a>删除</a>
                    </DeletePopconfirm>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} form={form} search={search} {...tableProps} toolbar={(
                <Space>
                    <AddButton type={'primary'} onClick={() => setVisible(true)}>新增</AddButton>
                    <AddButton type={'primary'} onClick={() => setUploadModalOpen(true)}>导入</AddButton>
                </Space>
            )}/>
            <ModifyModal {...modalProps} />
            <UploadModal onUpload={onImport}
                         open={uploadModalOpen}
                         title={'导入美年快递映射'}
                         template={'/template/美年快递映射导入模版.xlsx'}
                         confirmLoading={importing}
                         onCancel={() => setUploadModalOpen(false)}/>
        </PageHeaderLayout>
    )
}

export default ExternalExpress
